








































import { Vue, Component, Prop } from 'vue-property-decorator'
import { Maybe } from '@/types/general'

@Component({ name: 'v-checkbox' })
export default class VCheckbox extends Vue {
    /**
     * Value of the checkbox
     */
    checked: boolean = false

    /**
     * Internal value of the checkbox, allows use of
     * the v-model shortcut
     */
    @Prop({ type: Boolean, default: true })
    value!: boolean

    /**
     * The label positioned on the left of the checkbox
     */
    @Prop({ type: String, default: undefined })
    label!: Maybe<String>

    /**
     * The label positioned on the left of the checkbox
     */
    @Prop({ type: String, default: undefined })
    name!: string

    /**
     * Option to disable the checkbox
     */
    @Prop({ type: Boolean, default: false })
    disabled!: boolean

    /**
     * Text to show if the checkbox is disabled, in a
     * help pop-over
     */
    @Prop({ type: String, default: undefined })
    disabledText!: Maybe<string>

    /**
     * Whether to fix the width to 240px
     */
    @Prop({ type: Boolean, default: false })
    fixedWidth!: boolean

    /**
     * Style type
     */
    @Prop({ type: String, default: 'primary' })
    type!: string

    /**
     * Propagate an update to the value to the
     * parent component
     */
    update(value: boolean): void {
        this.$emit('input', value)
    }

    /**
     * Toggle this.checked and update the parent
     */
    toggle(event: KeyboardEvent): void {
        if (!event.key || event.key === ' ') {
            if (!this.disabled) {
                this.update(!this.value)
            }
        }
    }
}
